import React, { useState, useEffect } from "react";
import {
  OverlayTrigger,
  Tooltip,
  Popover,
} from "react-bootstrap";
import PriestApi from "../../api/priestApi";
import { toast } from "react-toastify";
import { ResponsiveDataList } from "../../components/responsive";
import Helpers from "../../components/Helpers";
import { sortParishesByName } from "../../utils/parishLabels";
import DeleteModel from "../../components/DeleteModal";
import { useAuthUser } from "../../hooks/useAuthUser";
import { setBrokenImageFallback } from "../../utils/imageFallback";
import { utils, writeFile } from "xlsx";
import AlertModal from "../../components/AlertModal";
import jsPDF from "jspdf";
import "jspdf-autotable";
import Profile from "../../assets/images/priest-default.png";
import corruptedImg from "../../assets/images/corrupted-img.png";
import AuthApi from "../../api/authApi";
import UpdatePriestPopUp from "./UpdatePriestPopUp";
import { useLocation } from "react-router-dom";
import { debounce } from "lodash";
import { PriestListHeaderActions } from "./manage/PriestListHeaderActions";
import { PriestListToolbar } from "./manage/PriestListToolbar";
import { PriestCard } from "./manage/cards/PriestCard";

const XLSX = require("xlsx");

const PriestList: React.FC = () => {
  const locationData = useLocation();
  const [validated, setValidated] = useState<boolean>(false);
  const [showRegModal, setShowREgModal] = useState<boolean>(false);
  const [isTempUpload, setIsTempUpload] = useState<boolean>(false);
  const [data, setData] = useState<Record<string, any>>({
    id: "",
    parishId: null,
    title: "",
    firstName: "",
    lastName: "",
    email: "",
    city: "",
    state: "",
    zip: "",
    imageUrl: "",
    address: "",
  });
  const [allPriestData, setAllPriestData] = useState<any[]>([]);
  const [ediUserIdClicked, setEdiUserIdClicked] = useState<any>("");
  const [total, setTotal] = useState<number>(20);
  const [searchKey, setSearchKey] = useState<string>("");
  const [show, setShow] = useState<boolean>(false);
  const [icon_id, setIcon_id] = useState<any>("");
  let authApi = new AuthApi();
  let priestApi = new PriestApi();
  const userData: Record<string, any> = useAuthUser() || null;
  const [LoadData, setLoadData] = useState<boolean>(false);
  const [roastersOfPriestList, setRoastersOfPriestList] = useState<any[]>([]);
  const [isEditAdmin, setIsEditAdmin] = useState<boolean>(false);
  const [parishList, setParishList] = useState<any[]>([]);
  const [roasterCount, setRoasterCount] = useState<any>("");
  const [oldValues, setOldValues] = useState<any[]>([]);
  const [alreadyPk, setAlreadyPk] = useState<any>();

  useEffect(() => {
    setSearchKey("");
    getAllPriestData(1, 20, null, {});
    getParishList();
    
  }, []);

  const checkPKPriest = async () => {
    await priestApi
      .checkPKPriest({} as any)
      .then((res) => {
        if (res.success) {
          if (res.data != null) {
            setAlreadyPk(res.data);
            let d = { ...data };
            d.primaryKey = res.data;
            setData(d);
          } else {
            let defaultPK = "P101";
            setAlreadyPk(defaultPK);
            let d = { ...data };
            d.primaryKey = defaultPK;
            setData(d);
          }
        } else {
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const getParishList = async () => {
    setLoadData(true);
    await authApi
      .getPerishList()
      .then((response) => {
        setParishList(sortParishesByName(response.data));
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const clearfield = () => {
    setData({
      id: "",
      parishId: null,
      title: "",
      firstName: "",
      lastName: "",
      email: "",
      city: "",
      state: "",
      zip: "",
      imageUrl: "",
      address: "",
    });
    setValidated(false);
  };

  const getAllPriestData = async (
    pageNo: any = 1,
    size: any = 20,
    searchKeyword: any = null,
    sortBy: any = {},
  ) => {
    setLoadData(true);
    let d: Record<string, any> = {};
    if (pageNo && size) {
      d.pageNo = pageNo;
      d.size = size;
    }
    if (searchKeyword !== null) {
      d.searchKeyword = searchKeyword;
    } else if (searchKey) {
      d.searchKeyword = searchKey;
    }
    if (sortBy?.sortColumn) {
      d.sortBy = sortBy;
    }
    d.export = false;
    await priestApi
      .getAllPriests(d)
      .then((res) => {
        if (res.success) {
          let totalRecords = res.totalRecords ? res.totalRecords : 0;
          setTotal(totalRecords);
          setAllPriestData(res.data);
          setLoadData(false);
        } else {
          setLoadData(false);
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        setLoadData(false);
        toast.error(error);
      });
  };

  const getroastersOfPriest = async (id) => {
    await priestApi
      .participatedInRetreats({ priest_Id: id })
      .then(async (response) => {
        setRoastersOfPriestList(response.data);
        setRoasterCount(response.totalRecords);
      })
      .catch((error) => {
        toast.error(error.toString());
      });
  };

  const editPriest = async (id) => {
    setIsTempUpload(false);
    setEdiUserIdClicked(id);
    let d = { ...data };
    try {
      const res = await priestApi.getPriestDetail({ priestId: id });
      if (!res.success) {
        toast.error(res.msg);
        return;
      }
      const priest = res.data;
      if (
        priest.email === "tkolkebeck@me.com" ||
        priest.email === "tkolkebeck@satx.rr.com" ||
        priest.email === "jimmieflores@gmail.com" ||
        priest.email === "dulceaflores@gmail.com"
      ) {
        setIsEditAdmin(true);
      }
      d.id = priest.id;
      d.primaryKey = priest.primaryKey;
      d.title = priest.title;
      d.firstName = priest.firstName;
      d.lastName = priest.lastName;
      d.email = priest.email;
      d.city = priest.city;
      d.state = priest.state;
      d.zip = priest.zip;
      d.parishId = priest.parishId;
      d.imageUrl = priest.imageUrl;
      d.address = priest.address;
      setData(d);
      setOldValues(priest);
      
    } catch (error) {
      console.error(error);
      toast.error("Failed to load priest details");
    }
  };

  const deletePriest = async () => {
    await priestApi
      .deletePriest({ priest_id: icon_id.id })
      .then(async (res) => {
        if (res.success) {
          getAllPriestData();
          setShow(false);
          setIcon_id("");
          checkPKPriest();
          toast.success(res.msg);
          
        } else {
          checkPKPriest();
          toast.error(res.msg);
        }
      })
      .catch((error) => {
        toast.error(error);
      });
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">{props}</Tooltip>
  );

  const popover = (row) => {
    return (
      <Popover id="popover-ImgPk" bsPrefix="popover">
        <Popover.Body>
          <div style={{ textAlign: "center", padding: "10px 0px" }}>
            {row.imageUrl ? (
              <span>
                <img
                  src={row.imageUrl}
                  className="column-rowImagePopover"
                  onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                />
              </span>
            ) : (
              <img src={Profile} className="column-rowImagePopover" />
            )}
            <h6 className="couplename">
              {" "}
              {row &&
                `${row.title ? `${row.title} ` : ""}${row.firstName} ${row.lastName}`}
            </h6>
          </div>
        </Popover.Body>
      </Popover>
    );
  };

  const columns = [
    ...(userData && userData.userRole === "ADMIN"
      ? [
          {
            id: "action",
            name: "Action",
            button: true,
            cell: (row) => (
              <>
                <button
                  className="font-size"
                  onClick={() => {
                    editPriest(row.id);
                    setShowREgModal(true);
                    getroastersOfPriest(row.id);
                  }}
                >
                  <i
                    className="mdi mdi-pencil-box text-lg text-primary font-size"
                    title="Edit"
                  />
                </button>
                <button className="font-size" onClick={() => handleShow(row)}>
                  <i
                    className="mdi mdi-delete-forever text-md text-danger mx-2 font-size"
                    title="Delete"
                  />
                </button>
              </>
            ),
            reorder: true,
          },
        ]
      : []),
    {
      id: "primaryKey",
      name: "Priest Id",
      selector: (row) => row.primaryKey,
      cell: (row) => (
        <OverlayTrigger placement="right" overlay={popover(row)}>
          {row.imageUrl ? (
            <span
              onClick={() => {
                editPriest(row.id);
                setShowREgModal(true);
                getroastersOfPriest(row.id);
              }}
            >
              <span className="roasterKey">
                {" "}
                <img
                  src={row.imageUrl}
                  className="column-rowImage"
                  onError={(e) => setBrokenImageFallback(e, corruptedImg)}
                />
              </span>
              {row.primaryKey && row.primaryKey}
            </span>
          ) : (
            <span
              onClick={() => {
                editPriest(row.id);
                setShowREgModal(true);
                getroastersOfPriest(row.id);
              }}
            >
              <span className="roasterKey">
                {" "}
                <img src={Profile} className="column-rowImage-profile" />
              </span>

              {row.primaryKey && row.primaryKey}
            </span>
          )}
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "120px",
    },
    {
      id: "Title",
      name: "Title",
      selector: (row) => row.title,
      cell: (row) => (
        <OverlayTrigger
          overlay={renderTooltip(`${row.title || ""}`)}
        >
          <span
            onClick={() => {
              editPriest(row.id);
              setShowREgModal(true);
              getroastersOfPriest(row.id);
            }}
          >
            {row.title ? `${row.title} ` : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
    },
    {
      id: "firstName",
      name: "First Name",
      selector: (row) => row.firstName,
      cell: (row) => (
        <OverlayTrigger
          overlay={renderTooltip(`${row.firstName}`)}
        >
          <span
            onClick={() => {
              editPriest(row.id);
              setShowREgModal(true);
              getroastersOfPriest(row.id);
            }}
          >
            {/* {row.title ? `${row.title} ` : ""} */}
            {row.firstName?.slice(0, 10)}
            {(row.firstName?.length || 0) > 10 ? "..." : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
    },
    {
      id: "lastName",
      name: "Last Name",
      selector: (row) => row.lastName,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.lastName)}>
          <span
            onClick={() => {
              editPriest(row.id);
              setShowREgModal(true);
              getroastersOfPriest(row.id);
            }}
          >
            {row.lastName?.slice(0, 10)}
            {row.lastName?.length > 10 ? "..." : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
    },
    {
      id: "email",
      name: "Email",
      selector: (row) => row.email,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.email)}>
          <a href={`mailto:${row.email}`}>
            <span>
              {row.email?.slice(0, 12)}
              {row.email?.length > 12 ? "..." : ""}
            </span>
          </a>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: { cursor: "text" },
      width: "150px",
    },
    {
      id: "Address",
      name: "Address",
      selector: (row) => row.address,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.address)}>
          <span>
            {row.address?.slice(0, 10)}
            {row.address?.length > 10 ? "..." : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      style: { cursor: "text" },
      width: "150px",
    },
    {
      id: "Parish",
      name: "Parish",
      selector: (row) => row.parish,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.parish)}>
          <span>{row.parish}</span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
      style: { cursor: "text" },
    },
    {
      id: "city",
      name: "City",
      selector: (row) => row.city,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.city)}>
          <span>
            {row.city?.slice(0, 10)}
            {row.city?.length > 10 ? "..." : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
    },
    {
      id: "state",
      name: "State",
      selector: (row) => row.state,
      cell: (row) => (
        <OverlayTrigger overlay={renderTooltip(row.state)}>
          <span>
            {row.state?.slice(0, 10)}
            {row.state?.length > 10 ? "..." : ""}
          </span>
        </OverlayTrigger>
      ),
      sortable: true,
      reorder: true,
      width: "150px",
    },
    {
      id: "zip",
      name: "Zip",
      selector: (row) => row.zip,
      sortable: true,
      reorder: true,
    },
    {
      id: "created",
      name: "Created",
      selector: (row) =>
        Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY"),
      cell: (row) => (
        <OverlayTrigger
          overlay={renderTooltip(
            Helpers.convertUtcToTimezone(row.createdAt, "DD-MM-YYYY hh:mm:a"),
          )}
        >
          <span>
            {Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY")}
          </span>
        </OverlayTrigger>
      ),
      reorder: true,
    },
  ];

  const handleShow = (item: any) => {
    setShow(true);
    setIcon_id(item);
  };

  const handleClose = () => {
    setShow(false);
  };

  const CloseCompose = () => {
    setIsEditAdmin(false);
    setValidated(false);
    setShowREgModal(false);
    setEdiUserIdClicked("");
    clearfield();
  };

  // Debounced search function
  const debouncedSearch = React.useMemo(
    () =>
      debounce((value) => {
        getAllPriestData(1, 20, value, {});
      }, 500),
    [], // Empty dependency array ensures debounce is created only once
  );

  const SearchData = (event) => {
    const value = event.target.value;
    setSearchKey(value);
    debouncedSearch(value);
  };

  const handleExport = async () => {
    try {
      let d = {
        pageNo: 1,
        size: 20,
        export: true,
      };

      const res = await priestApi.getAllPriests(d);

      if (!res.success) {
        return toast.error(res.msg);
      }

      const exportData = res.data.map((element) => ({
        primaryKey: element.primaryKey || "",
        title: element.title || "",
        firstName: element.firstName || "",
        lastName: element.lastName || "",
        email: element.email || "",
        mobile: element.mobile || "",
        address: element.address || "",
        city: element.city || "",
        state: element.state || "",
        zip: element.zip || "",
        parish: element.parish || "",
      }));

      const headings = [
        [
          "Priest Id",
          "Title",
          "First Name",
          "Last Name",
          "Email",
          "Mobile",
          "Address",
          "City",
          "State",
          "Zip",
          "Parish",
        ],
      ];

      const wb = utils.book_new();
      const ws = utils.json_to_sheet([]);

      utils.sheet_add_aoa(ws, headings);
      utils.sheet_add_json(ws, exportData, {
        origin: "A2",
        skipHeader: true,
      });

      utils.book_append_sheet(wb, ws, "Data");
      writeFile(wb, "Priest_Data.xlsx");

      
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  const exportPdf = async () => {
    try {
      const doc = new jsPDF("landscape", "pt", "A1");
      const marginLeft = 40;

      doc.setFontSize(15);
      doc.text("All Priests", marginLeft, 40);

      const headers = [
        [
          "Priest Id",
          "Title",
          "First Name",
          "Last Name",
          "Email",
          "Mobile",
          "Address",
          "City",
          "State",
          "Zip",
          "Parish",
        ],
      ];

      const res = await priestApi.getAllPriests({
        pageNo: 1,
        size: 20,
        export: true,
      });

      if (!res.success) {
        return toast.error(res.msg);
      }

      const data = res.data.map((element) => [
        element.primaryKey || "",
        element.title || "",
        element.firstName || "",
        element.lastName || "",
        element.email || "",
        element.mobile || "",
        element.address || "",
        element.city || "",
        element.state || "",
        element.zip || "",
        element.parish || "",
      ]);

      (doc as any).autoTable({
        head: headers,
        body: data,
        startY: 70,
        theme: "grid",
        styles: {
          fontSize: 8,
          cellPadding: 3,
          overflow: "linebreak",
        },
        headStyles: {
          fillColor: [22, 160, 133],
          textColor: 255,
        },
        columnStyles: {
          0: { cellWidth: 60 },
          1: { cellWidth: 50 },
          2: { cellWidth: 80 },
          3: { cellWidth: 80 },
          4: { cellWidth: 150 },
          5: { cellWidth: 80 },
          6: { cellWidth: 150 },
          7: { cellWidth: 80 },
          8: { cellWidth: 60 },
          9: { cellWidth: 60 },
          10: { cellWidth: 120 },
        },
        margin: { left: marginLeft, right: 40 },
      });

      doc.save("Priest_Report.pdf");

      
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  return (
    <>
      <PriestListHeaderActions
        onCreate={() => {
          setShowREgModal(true);
          checkPKPriest();
          clearfield();
        }}
      />

      <div className="row ext-space">
        <div className="col-lg-12 d-flex flex-column">
          <div className="row flex-grow">
            <div className="col-12 grid-margin stretch-card">
              <div className="card custom-card">
                <div className="card-body ">
                  <PriestListToolbar
                    total={total}
                    searchKey={searchKey}
                    onSearch={SearchData}
                    isAdmin={userData?.userRole === "ADMIN"}
                    onExportExcel={handleExport}
                    onExportPdf={exportPdf}
                  />
                  <ResponsiveDataList
                    loading={LoadData}
                    data={allPriestData}
                    columns={columns}
                    total={total}
                    countPerPage={20}
                    isServerSide
                    pagination
                    sortServer
                    dataFetchApi={(pageNo, size, _search, sortBy) =>
                      getAllPriestData(pageNo, size, searchKey || null, sortBy || {})
                    }
                    pointerOnHover
                    highlightOnHover
                    forCouple
                    cardGridColumns={{ xs: "1fr", md: "repeat(2, minmax(0, 1fr))" }}
                    renderCard={(row) => (
                      <PriestCard
                        row={row}
                        isAdmin={userData?.userRole === "ADMIN"}
                        onEdit={(r) => {
                          editPriest(r.id);
                          setShowREgModal(true);
                          getroastersOfPriest(r.id);
                        }}
                        onDelete={handleShow}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {show ? (
          <DeleteModel
            show={show}
            content={
              <>
                <h5 className="mt-4 fw-bold">
                  Spiritual Director (Priest) Detail
                </h5>

                <div className="p-3 border rounded-3 bg-light shadow-sm">
                  {/* Priest Name */}
                  {(icon_id.firstName || icon_id.lastName) && (
                    <div className="mb-2">
                      <span className="fw-bold">Name:</span> {icon_id.firstName}{" "}
                      {icon_id.lastName}
                    </div>
                  )}

                  {/* Email */}
                  {icon_id.email && (
                    <div className="mb-2">
                      <span className="fw-bold">Email:</span>{" "}
                      <span className="text-muted">{icon_id.email}</span>
                    </div>
                  )}

                  {/* Parish */}
                  {icon_id.parish && (
                    <div className="mb-2">
                      <span className="fw-bold">Parish:</span>{" "}
                      <span className="text-muted">{icon_id.parish}</span>
                    </div>
                  )}

                  {/* Phone (optional) */}
                  {icon_id.phone && (
                    <div>
                      <span className="fw-bold">Phone:</span>{" "}
                      <span className="text-muted">{icon_id.phone}</span>
                    </div>
                  )}
                </div>
              </>
            }
            handleClose={handleClose}
            DeleteData={deletePriest}
          />
        ) : null}

        {showRegModal ? (
          <UpdatePriestPopUp
            showRegModal={showRegModal}
            setShowREgModal={setShowREgModal}
            setEdiUserIdClicked={setEdiUserIdClicked}
            onHide={() => {
              CloseCompose();
              clearfield();
              setEdiUserIdClicked("");
            }}
            closeButton={() => {
              checkPKPriest();
              setEdiUserIdClicked("");
              CloseCompose();
              getAllPriestData();
            }}
            userData={userData}
            isEditAdmin={isEditAdmin}
            parishList={parishList}
            setParishList={setParishList}
            ediUserIdClicked={ediUserIdClicked}
            CloseCompose={CloseCompose}
            roasterCount={roasterCount}
            roastersOfPriestList={roastersOfPriestList}
            getAllPriests={getAllPriestData}
            data={data}
            setData={setData}
            oldValues={oldValues}
            setOldValues={setOldValues}
            isTempUpload={isTempUpload}
            setIsTempUpload={setIsTempUpload}
          />
        ) : null}
      </div>
    </>
  );
};

export default PriestList;
